import { _ as _tagged_template_literal } from "@swc/helpers/_/_tagged_template_literal";
function _templateObject() {
    const data = _tagged_template_literal([
        "\n  display: flex;\n  gap: 8px;\n\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 1.5;\n  letter-spacing: -0.16px;\n\n  &,\n  dt {\n    font-weight: 400;\n    color: ",
        ";\n  }\n\n  &,\n  dd {\n    margin-bottom: 0;\n  }\n\n  dd {\n    display: flex;\n    justify-content: flex-end;\n    flex-grow: 1;\n\n    &.discount {\n      color: ",
        ";\n    }\n\n    strong {\n      color: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
import styled from "styled-components";
export const OrderSummaryItem = styled.dl.withConfig({
    componentId: "sc-fcb63891-0"
})(_templateObject(), (props)=>props.theme.new.colors.sol_gray_500, (props)=>props.theme.new.colors.sol_red_400, (props)=>props.theme.new.colors.sol_gray_900);
